export class SignStockOfferSentStatusRequest {
  signId: number;
  offerIsSent: boolean;
}
